import React from 'react'
import PropTypes from 'prop-types'

import BackButton from '../BackButton'

import Styles from './styles.scss'


export default function DetailsHeader({ handleBackClick, title }) {
  return (
    <div className={ Styles.root }>
      <BackButton
        className={ Styles.button }
        handleClick={ handleBackClick }
        type="outline"
      />

      <h2 className={ Styles.title }>
        { title }
      </h2>
    </div>
  )
}

DetailsHeader.propTypes = {
  handleBackClick: BackButton.propTypes.handleClick,
  title: PropTypes.string.isRequired,
}
